const STORAGE_KEY = 'baby-workbench-key';
const SESSION_KEY = 'baby-workbench-session-key';

export function loadSavedKey() {
  return localStorage.getItem(STORAGE_KEY) ?? sessionStorage.getItem(SESSION_KEY) ?? '';
}

export function saveKey(key, remember) {
  sessionStorage.setItem(SESSION_KEY, key);
  if (remember) localStorage.setItem(STORAGE_KEY, key);
  else localStorage.removeItem(STORAGE_KEY);
}

export function clearSavedKey() {
  localStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(SESSION_KEY);
}

export function createApi(key) {
  async function request(path, options = {}) {
    const response = await fetch(path, {
      ...options,
      headers: {
        ...(options.body ? { 'content-type': 'application/json' } : {}),
        'x-workspace-key': key,
        ...options.headers,
      },
    });

    if (!response.ok) {
      let message = `请求失败 (${response.status})`;
      try {
        const body = await response.json();
        if (body.error) message = body.error;
      } catch {
        // Keep the status-based message when the response is not JSON.
      }
      throw new Error(message);
    }

    if (response.status === 204) return null;
    return response.json();
  }

  return {
    bootstrap: () => request('/api/bootstrap'),
    createEvent: (event, requestId = crypto.randomUUID()) => request('/api/events', {
      method: 'POST',
      headers: { 'x-client-request-id': requestId },
      body: JSON.stringify(event),
    }),
    updateEvent: (id, event) => request(`/api/events/${id}`, {
      method: 'PUT',
      body: JSON.stringify(event),
    }),
    deleteEvent: (id) => request(`/api/events/${id}`, { method: 'DELETE' }),
    stopSleep: (endedAt) => request('/api/sleep/stop', {
      method: 'POST',
      body: JSON.stringify({ endedAt }),
    }),
    updateProfile: (profile) => request('/api/profile', {
      method: 'PUT',
      body: JSON.stringify(profile),
    }),
    saveVaccination: (scheduleId, record) => request(`/api/vaccinations/${scheduleId}`, {
      method: 'PUT',
      body: JSON.stringify(record),
    }),
    deleteVaccination: (scheduleId) => request(`/api/vaccinations/${scheduleId}`, { method: 'DELETE' }),
  };
}
